import {
  GET_ALL,
  GET_ALL_FAILURE,
  GET_ALL_SUCCESS,
  ADD,
  ADD_FAILURE,
  ADD_SUCCESS,
  DELETE,
  DELETE_FAILURE,
  DELETE_SUCCESS,
  EDIT,
  EDIT_FAILURE,
  EDIT_SUCCESS,
  GET,
  GET_FAILURE,
  GET_SUCCESS,
} from "./actionTypes";

//actions types for Employee

export const getAllEmployees = (payload) => {
  return {
    type: GET_ALL,
    payload: payload,
  };
};
export const getAllEmployeesSuccess = (payload) => {
  return {
    type: GET_ALL_SUCCESS,
    payload: payload,
  };
};

export const getAllEmployeesFailure = (error) => {
  return {
    type: GET_ALL_FAILURE,
    payload: error,
  };
};

export const addEmployee = (payload) => {
  return {
    type: ADD,
    payload: payload,
  };
};
export const addEmployeeSuccess = (payload) => {
  return {
    type: ADD_SUCCESS,
    payload: payload,
  };
};

export const addEmployeeFailure = (error) => {
  return {
    type: ADD_FAILURE,
    payload: error,
  };
};

export const getEmployee = (payload) => {
  return {
    type: GET,
    payload: payload,
  };
};
export const getEmployeeSuccess = (payload) => {
  return {
    type: GET_SUCCESS,
    payload: payload,
  };
};

export const getEmployeeFailure = (error) => {
  return {
    type: GET_FAILURE,
    payload: error,
  };
};

export const editEmployee = (payload) => {
  return {
    type: EDIT,
    payload: payload,
  };
};
export const editEmployeeSuccess = (payload) => {
  return {
    type: EDIT_SUCCESS,
    payload: payload,
  };
};

export const editEmployeeFailure = (error) => {
  return {
    type: EDIT_FAILURE,
    payload: error,
  };
};

export const deleteEmployee = (payload) => {
  return {
    type: DELETE,
    payload: payload,
  };
};

export const deleteEmployeeSuccess = (payload) => {
  return {
    type: DELETE_SUCCESS,
    payload: payload,
  };
};

export const deleteEmployeeFailure = (error) => {
  return {
    type: DELETE_FAILURE,
    payload: error,
  };
};
